'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { i18n } from 'react-i18n'
import $ from 'jquery'
import LinnerDiv from './lineDiv'
import IntialData from '../utility/getTemplateData'

let PropTypes = React.PropTypes

export default React.createClass({

    mixins: [i18n('common/pPLogIn')],

    propTypes:{
        label: React.PropTypes.string
    },

    getInitialState () {
        return {};
    },

    render () {

        let havePPLabel = this.i18n('label.havePP')
        let logInLabel = this.i18n('label.logIn')

        return (
        	<div>
	        	<div className="row text-center donate_pp_login_wrapper">
					<div className="col-xs-7 col-sm-7 col-md-7 have_pp_label">
                        <p className="have_pp_text">{havePPLabel}</p>
					</div>
					<div className="col-xs-5 col-sm-5 col-md-5">
                        <a className="btn btn-primary have_pp_btn" onClick={this.props.handleLogIn}>{logInLabel}</a>
                    </div>
				</div>
			</div>
        );
    }
});




/** WEBPACK FOOTER **
 ** ./common/pPLogIn.js
 **/